import { ProductInterface, ProductVariantInterface } from "@qlevr/shared/interfaces";

export function getVariantForProduct(product: ProductInterface, variantIds: string[]): ProductVariantInterface | undefined {
    return product.variants?.find((variant) => variantIds.includes(variant.id));
}
